var _StyledCulturePickerN, _ExpandMoreIcon, _ExpandMoreIcon2, _Translate, _ExpandMoreIcon3, _Translate2, _IngramLogoBlackX4C;
/* eslint-disable max-lines */

import React, { useMemo } from 'react';
import { Translate } from '@im/react-localization';
import { styled, useTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { NavLink } from '../NavLink';
import { IngramLogoBlackX4C } from '../icons/IngramLogoBlackX4C';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { CulturePickerNew } from '../CulturePicker/CulturePickerNew';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function FooterLinks(props) {
  var links = props.links;
  var footerLinkNavItem = function footerLinkNavItem(link) {
    var _link$linkUrl, _link$linkUrl2;
    var navItem = {
      key: link.name,
      label: link.linkText ? link.linkText : link.name
    };
    if (link.linkType === 'Footer Icon') {
      navItem.content = /*#__PURE__*/_jsx("img", {
        alt: link.linkText,
        src: link.iconImage,
        style: {
          maxHeight: '24px',
          maxWidth: '24px'
        }
      });
      switch (link.iconValueType) {
        case 'Email':
          navItem.url = "mailto:".concat(link.email);
          break;
        case 'Mobile':
          navItem.url = "tel:".concat(link.mobile);
          break;
        default:
          if (!link.openInNewWindow && (_link$linkUrl = link.linkUrl) != null && _link$linkUrl.includes('/cep/app/')) {
            navItem.route = link.linkUrl.replace('/cep/app/', '/');
          } else {
            navItem.url = link.linkUrl;
          }
      }
    } else if (!link.openInNewWindow && (_link$linkUrl2 = link.linkUrl) != null && _link$linkUrl2.includes('/cep/app/')) {
      navItem.route = link.linkUrl.replace('/cep/app/', '/');
    } else {
      navItem.url = link.linkUrl;
    }
    return navItem;
  };
  var navItems = useMemo(function () {
    return links ? links.map(function (link) {
      return footerLinkNavItem(link);
    }) : [];
  }, [links]);
  return /*#__PURE__*/_jsx(Grid, {
    container: true,
    flexDirection: {
      sm: 'row',
      xs: 'column'
    },
    "data-element": "Grid",
    "data-component": "FooterLinks",
    "data-source-file": "FooterMobile.tsx",
    children: navItems.map(function (navItem) {
      return /*#__PURE__*/_jsx(Grid, {
        item: true,
        sx: {
          marginTop: '8px',
          maxWidth: '100%'
        },
        xs: 6,
        children: /*#__PURE__*/_jsx(StyledNavLink, {
          "data-testid": "".concat(navItem.key),
          navItem: navItem
        })
      }, navItem.key);
    })
  });
}
export function FooterMobile(props) {
  var appStore = props.appStore,
    copyRightLinks = props.copyRightLinks,
    footerAction = props.footerAction,
    footerColumns = props.footerColumns,
    socialMedias = props.socialMedias;
  var theme = useTheme();
  var socialMediaNavItems = useMemo(function () {
    return socialMedias ? socialMedias.map(function (media) {
      return {
        content: /*#__PURE__*/_jsx("img", {
          alt: media.name,
          src: typeof media.iconImage === 'string' ? media.iconImage : ''
        }),
        key: media.name,
        label: media.name,
        url: media.url
      };
    }) : [];
  }, [socialMedias]);
  var appStoreNavItems = useMemo(function () {
    return appStore ? appStore.map(function (media) {
      return {
        content: /*#__PURE__*/_jsx("img", {
          alt: media.name,
          src: typeof media.iconImage === 'string' ? media.iconImage : ''
        }),
        key: media.name,
        label: media.name,
        url: media.url
      };
    }) : [];
  }, [appStore]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(RootStack, {
      "data-testid": "footer-mobile",
      "data-element": "RootStack",
      "data-source-file": "FooterMobile.tsx",
      children: /*#__PURE__*/_jsxs(Stack, {
        alignItems: "flex-start",
        direction: "column",
        justifyContent: "flex-start",
        spacing: "24px",
        "data-element": "Stack",
        "data-source-file": "FooterMobile.tsx",
        children: [/*#__PURE__*/_jsx(ThemeProvider, {
          theme: {
            components: {
              MuiMenuItem: {
                styleOverrides: {
                  root: {
                    color: "".concat(theme.palette.grey[600]),
                    fontSize: '12px',
                    fontWeight: '600',
                    lineHeight: '16px',
                    minHeight: '16px'
                  }
                }
              }
            }
          },
          "data-element": "ThemeProvider",
          "data-source-file": "FooterMobile.tsx",
          children: _StyledCulturePickerN || (_StyledCulturePickerN = /*#__PURE__*/_jsx(StyledCulturePickerNew, {
            "data-element": "StyledCulturePickerNew",
            "data-source-file": "FooterMobile.tsx"
          }))
        }), footerAction && /*#__PURE__*/_jsx(Button, {
          "aria-label": footerAction.title,
          "data-name": footerAction.trackingTag,
          onClick: footerAction.onClick,
          sx: {
            width: '100%'
          },
          variant: "newContained",
          children: /*#__PURE__*/_jsx(Typography, {
            sx: {
              lineHeight: '22px'
            },
            variant: "body2",
            children: footerAction.title
          })
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1px',
            width: '100%'
          },
          children: [footerColumns && footerColumns.map(function (column, index) {
            return /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsxs(StyledAccordian, {
                children: [/*#__PURE__*/_jsx(AccordionSummary, {
                  "aria-controls": "panel1a-content",
                  expandIcon: _ExpandMoreIcon || (_ExpandMoreIcon = /*#__PURE__*/_jsx(ExpandMoreIcon, {})),
                  id: "panel1a-header",
                  children: /*#__PURE__*/_jsx(StyledTypography, {
                    "data-testid": "footer-".concat(column.footerColumn.name),
                    variant: "bodycopysemibold",
                    children: column.footerColumn.name
                  })
                }), /*#__PURE__*/_jsx(AccordionDetails, {
                  children: /*#__PURE__*/_jsx(FooterLinks, {
                    links: column.footerColumn.links
                  })
                })]
              }), /*#__PURE__*/_jsx(Divider, {
                sx: {
                  height: '1px'
                }
              })]
            }, "footer-".concat(column.footerColumn.name));
          }), socialMedias && socialMedias.length > 0 || appStore && appStore.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs(StyledAccordian, {
              children: [/*#__PURE__*/_jsx(AccordionSummary, {
                expandIcon: _ExpandMoreIcon2 || (_ExpandMoreIcon2 = /*#__PURE__*/_jsx(ExpandMoreIcon, {})),
                children: /*#__PURE__*/_jsx(StyledTypography, {
                  "data-testid": "footer-ShareYourStory",
                  sx: {
                    color: "".concat(theme.palette.grey[600])
                  },
                  variant: "bodycopysemibold",
                  children: _Translate || (_Translate = /*#__PURE__*/_jsx(Translate, {
                    text: "Footer.ShareYourStory"
                  }))
                })
              }), /*#__PURE__*/_jsx(AccordionDetails, {
                children: socialMedias && /*#__PURE__*/_jsx(Stack, {
                  direction: "row",
                  gap: 1,
                  sx: {
                    marginBottom: '8px'
                  },
                  children: socialMediaNavItems.map(function (media) {
                    return /*#__PURE__*/_jsx(StyledSocialMediaNavLink, {
                      "aria-label": media.key,
                      "data-testid": "".concat(media.key, "-follow-us-icon"),
                      navItem: media,
                      rel: "noopener noreferrer"
                    }, media.key);
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Divider, {
              sx: {
                height: '1px'
              }
            }), appStore && !!(appStoreNavItems != null && appStoreNavItems.length) && /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(StyledAccordian, {
                children: [/*#__PURE__*/_jsx(AccordionSummary, {
                  expandIcon: _ExpandMoreIcon3 || (_ExpandMoreIcon3 = /*#__PURE__*/_jsx(ExpandMoreIcon, {})),
                  children: /*#__PURE__*/_jsx(StyledTypography, {
                    "data-testid": "footer-follow-us",
                    sx: {
                      color: "".concat(theme.palette.grey[600])
                    },
                    variant: "bodycopysemibold",
                    children: _Translate2 || (_Translate2 = /*#__PURE__*/_jsx(Translate, {
                      text: "Footer.downloadApp"
                    }))
                  })
                }), /*#__PURE__*/_jsx(AccordionDetails, {
                  children: /*#__PURE__*/_jsxs(Grid, {
                    alignItems: "center",
                    container: true,
                    gap: '16px',
                    justifyContent: "start",
                    marginBottom: 1,
                    marginTop: 1,
                    children: [/*#__PURE__*/_jsx(Stack, {
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '12px',
                      children: appStoreNavItems.map(function (store) {
                        return /*#__PURE__*/_jsx(StyledAppStoreNavLink, {
                          "aria-label": store.key,
                          "data-testid": "".concat(store.key, "-follow-us-icon"),
                          navItem: store,
                          rel: "noopener noreferrer"
                        }, store.key);
                      })
                    }), /*#__PURE__*/_jsx("img", {
                      alt: "App Download QR Code",
                      height: "95px",
                      src: "/cep/assets/img/app-download-qr-code.png",
                      style: {
                        borderRadius: '6px',
                        boxShadow: '0px 2px 7px 0px #00000040',
                        padding: '3px'
                      },
                      width: "95px"
                    })]
                  })
                })]
              })
            })]
          }) : null]
        }), /*#__PURE__*/_jsx(Stack, {
          alignItems: "flex-start",
          sx: {
            padding: '8px 0px 8px 8px'
          },
          "data-element": "Stack",
          "data-source-file": "FooterMobile.tsx",
          children: _IngramLogoBlackX4C || (_IngramLogoBlackX4C = /*#__PURE__*/_jsx(IngramLogoBlackX4C, {
            "data-element": "IngramLogoBlackX4C",
            "data-source-file": "FooterMobile.tsx"
          }))
        }), /*#__PURE__*/_jsx(Box, {
          "data-element": "Box",
          "data-source-file": "FooterMobile.tsx",
          children: /*#__PURE__*/_jsx(Stack, {
            direction: "row",
            sx: {
              borderTop: "1px solid ".concat(theme.palette.grey[200]),
              paddingTop: '20px'
            },
            "data-element": "Stack",
            "data-source-file": "FooterMobile.tsx",
            children: /*#__PURE__*/_jsxs(Stack, {
              "data-element": "Stack",
              "data-source-file": "FooterMobile.tsx",
              children: [/*#__PURE__*/_jsx(StyledTypography, {
                sx: {
                  color: "".concat(theme.palette.grey[600]),
                  fontSize: '12px',
                  lineHeight: '16px'
                },
                variant: "bodycopyregular",
                "data-element": "StyledTypography",
                "data-source-file": "FooterMobile.tsx",
                children: /*#__PURE__*/_jsx(Translate, {
                  params: {
                    year: new Date().getFullYear().toString()
                  },
                  text: "Footer.CopyrightMedium",
                  "data-element": "Translate",
                  "data-source-file": "FooterMobile.tsx"
                })
              }), /*#__PURE__*/_jsx(Stack, {
                "data-element": "Stack",
                "data-source-file": "FooterMobile.tsx",
                children: /*#__PURE__*/_jsx(Stack, {
                  direction: "row",
                  sx: {
                    flexWrap: 'wrap'
                  },
                  "data-element": "Stack",
                  "data-source-file": "FooterMobile.tsx",
                  children: copyRightLinks && copyRightLinks.map(function (link, index) {
                    return /*#__PURE__*/_jsxs("div", {
                      children: [/*#__PURE__*/_jsx(StyledNavLink, {
                        className: "responsive-font",
                        "data-name": link.trackingTag,
                        "data-testid": link.title,
                        linkTarget: link.openUrlInNewTab ? '_blank' : '_self',
                        navItem: {
                          key: link.title,
                          label: link.title,
                          onClick: link.onClick,
                          route: link.route,
                          url: link.url
                        },
                        sx: {
                          fontSize: '12px',
                          lineHeight: '16px'
                        }
                      }, link.title), index < (copyRightLinks == null ? void 0 : copyRightLinks.length) - 1 && /*#__PURE__*/_jsx(StyledTypography, {
                        sx: {
                          margin: '0 10px'
                        },
                        variant: "bodycopyregular",
                        children: '|'
                      })]
                    }, link.title);
                  })
                })
              })]
            })
          })
        })]
      })
    })
  });
}
var RootStack = styled(Stack)(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: 'transparent',
    height: '100%',
    maxWidth: '768px',
    padding: '24px 16px',
    width: '100%'
  };
});
var StyledCulturePickerNew = styled(CulturePickerNew)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& .MuiSelect-icon': {
      color: 'inherit',
      fontSize: '16px'
    },
    '.MuiOutlinedInput-input': {
      padding: 0
    },
    color: theme.palette.grey[600],
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px'
  };
});
var StyledAccordian = styled(Accordion)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    '.MuiAccordionSummary-root': {
      '.MuiAccordionSummary-content': {
        '&.Mui-expanded': {
          padding: '12px 0 16px 0px'
        },
        padding: '12px 0 12px 0px'
      },
      '.MuiAccordionSummary-expandIconWrapper': {
        '&.Mui-expanded': {
          padding: '0px'
        },
        height: '18px',
        padding: 0,
        width: '18px'
      },
      border: 0
    },
    '.MuiCollapse-root': {
      '&.Mui-expanded': {
        margin: 0,
        padding: '12px 0 16px 0px'
      },
      '&.MuiAccordion-root': {
        '&.Mui-expanded': {
          padding: '0px 0 16px 0px'
        },
        borderRadius: '0px'
      },
      '&.MuiCollapse-entered': {
        border: 0
      },
      '.MuiAccordionDetails-root': {
        padding: '0px'
      }
    },
    borderRadius: '0px',
    margin: 0
  };
});
var StyledTypography = styled(Typography)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.palette.grey[700]
  };
});
var StyledNavLink = styled(NavLink)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.info[900],
      textDecoration: 'underline'
    },
    color: theme.palette.grey[600],
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '22px'
  };
});
var StyledSocialMediaNavLink = styled(NavLink)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    '& img': {
      height: '24px',
      width: '24px'
    },
    backgroundColor: 'transparent',
    height: '24px',
    width: '24px'
  };
});
var StyledAppStoreNavLink = styled(NavLink)(function (_ref7) {
  var theme = _ref7.theme;
  return {
    '& img': {
      height: '40px',
      width: '135px'
    },
    backgroundColor: 'transparent',
    height: '40px',
    width: '135px'
  };
});